import React from 'react';
import { Divider, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import {
    CollapsibleGroup,
    Collapsible,
    CollapsibleHeader,
    CollapsibleContent,
    CollapsibleHeaderChevron,
} from '@fiverr-private/disclosure';
import { translate } from '@fiverr-private/i18n-react';
import { TITLE_SIZE } from '../../consts';
import { useVerticalFlowEvents } from '../../hooks/useVerticalFlowEvents';

export const FAQs = () => {
    const NO_OF_QUESTIONS = 10;
    const { impressionRef, reportClickEvent } = useVerticalFlowEvents('FAQs');

    return (
        <Stack
            ref={impressionRef}
            direction="column"
            maxWidth="1108px"
            alignSelf="center"
            marginX="8"
            marginY="16"
            onClick={reportClickEvent}
        >
            <Typography size={TITLE_SIZE} color="grey_1200">
                {translate('vibe_coding_perseus.FAQs.title')}
            </Typography>
            <CollapsibleGroup>
                {Array.from({ length: NO_OF_QUESTIONS }, (_, i) => (
                    <Stack key={`question_${i + 1}`} direction="column" paddingBottom="3">
                        <Collapsible>
                            <CollapsibleHeader>
                                {translate(`vibe_coding_perseus.FAQs.questions.question_${i + 1}.question`)}
                                <CollapsibleHeaderChevron />
                            </CollapsibleHeader>
                            <CollapsibleContent>
                                {translate(`vibe_coding_perseus.FAQs.questions.question_${i + 1}.answer`)}
                            </CollapsibleContent>
                        </Collapsible>
                        <Divider />
                    </Stack>
                ))}
            </CollapsibleGroup>
        </Stack>
    );
};
